export enum SegmentUserType {
  GuestOpenbay = 'Guest-Openbay',
  GuestLyft = 'Guest-Lyft',
  RegisteredOpenbay = 'Registered-Openbay',
  RegisteredFacebook = 'Registered-Facebook',
  RegisteredLyft = 'Registered-Lyft',
  RegisteredPlus = 'Registered-Plus'
}
